import { useCallback, useEffect, useState } from "react";
import { ItemInfo, ItemList } from "../types";
import getItemList from "../api/itemListApi";

export default function useItemList() {
  const [total, setTotal] = useState<number>();
  const [itemList, setItemList] = useState<ItemList[]>([]);

  const get = useCallback(async () => {
    try {
      const res = await getItemList();
      if(res){
        setItemList(res.list)
        setTotal(res.total)
      }
    }catch(error) {
      console.error("error", error);
    }
  }, [])

  useEffect(() => {
    (async () => {
      await get();
    })();
  }, []);

  return [{total, itemList}, { get }] as const;
}